// extracted by css-extract-rspack-plugin
export default {"row":"oCpFNi7Q9Y0tap90","label":"DaJcU7o2pUozQ9nd"};